import React from 'react';

const Footer = () => {
  return (
    <div className='w-full bg-[#0c4a6e] py-16 text-white'>
      <div className='max-w-[1240px] mx-auto flex flex-col px-4'>
        <div className='block justify-between text-center'>
          <p className='py-4'>
          Renon, Denpasar Selatan, Panjer, Denpasar Selatan, Kota Denpasar, Bali 80234<br /> Phone: +62 8123 8095 684 {' | '} Email: kakekenyat21@gmail.com <br/><br/>All rights reserved BaliFather © 2022
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
